module.exports = __webpack_public_path__ + "148d815d8a9bc815acbf0f9fb28fb016.svg";